
import { Component, Vue, Watch } from 'vue-property-decorator';
import FakeSearch from '@/components/home/FakeSearch.vue';
import Follow from '@/components/follow/Follow.vue';
import AllReport from '@/components/select/AllReport.vue';
import CommonReportHeader from '@/components/common/CommonReportHeader.vue';
import SingleRank from '@/components/home/SingleRank.vue';
import AllScreen from '@/components/home/AllScreen.vue';
import ReportBlock from '@/components/home/ReportBlock.vue';
import IndustryRank from '@/components/home/IndustryRank.vue';
import AnalystAgencyRank from '@/components/home/AnalystAgencyRank.vue';
import ReportClassTip from '@/components/home/ReportClassTip.vue';
import EnterPopup from '@/components/home/EnterPopup.vue';
import CommonTab from '@/components/common/CommonTab.vue';
import HomeAllReport from '@/components/home/AllReport.vue';
import CommonBlockLine from '@/components/common/CommonBlockLine.vue';
import CommonBlockTitle from '@/components/common/CommonBlockTitle.vue';
import CommonDropMenu from '@/components/common/CommonDropMenu.vue';
import CommonTableHead from '@/components/common/CommonTableHead.vue';
import {
  homeTitle,
  homeTabList,
  hotDropMenu,
  STAT,
  URLVER,
  BUSINESS_CONFIG,
  SUCCESS_CODE,
  SWIPER_FIRST_INDEX,
} from '@/config/config';
import { tabProject } from '@/types/tabList';
import { dropMenuProject } from '@/types/dropMenu';
import {
  pushBy2804,
  getClientHeight,
  jumpBy2804,
  getUrlByPromise,
  jumpTimeShare,
  appLogin,
} from '@/utils/tools';
import { Pay } from '@/utils/usePay';
import Swiper from 'swiper';
import { getOperateConfig } from '@/apis/index';
import allLink from '@/config/url';
import 'swiper/css';
import HotBlockCard from '@/components/home/HotBlockCard.vue';
import ExploreReportCard from '@/components/home/ExploreReportCard.vue';
import { statShow } from '@/config/stat';
import { registerWebListener } from '@king-fisher/mobileweb-lib';
import { initBackwash } from '@/utils/backwash';

@Component({
  components: {
    CommonTab,
    CommonBlockLine,
    CommonBlockTitle,
    CommonDropMenu,
    CommonTableHead,
    SingleRank,
    ReportBlock,
    AnalystAgencyRank,
    IndustryRank,
    Follow,
    HomeAllReport,
    AllReport,
    CommonReportHeader,
    FakeSearch,
    AllScreen,
    ReportClassTip,
    EnterPopup,
    HotBlockCard,
    ExploreReportCard,
  },
})
export default class HomeView extends Vue {
  // 全部研报默认选择
  allDefault = '最新';
  //当前是上滑还是下滑，控制.screen显隐
  screenShow = 0;
  //是否看深度研报
  deep = false;
  //是否展示图表
  chart = true;
  //空状态样式
  emptyStyle = {
    position: 'absolute',
    top: '6.92rem',
    left: '2.55rem',
    fontFamily: 'PingFangSC-Regular',
    fontSize: '0.32rem',
    color: 'rgba(0, 0, 0, 0.84)',
    textAlign: 'center',
    lineHeight: '0.4rem',
  };
  allDropMenu = hotDropMenu;
  allReportSelecter = {
    isDeep: false,
    isShowChart: true,
    queryInfo: {},
    period: '',
  };
  // 主要tab活动的索引
  activeTabIndex = 0;
  // 模块标题信息
  homeTitle = homeTitle;
  // 主tab信息
  tabList: tabProject[] = homeTabList;
  // 主滑动切换
  mySwiper: any = null;
  // scrollTop值
  scrollTop = 0;
  // 顶部搜索bar和tab状态样式
  barStyle = null;
  selectPosition = null;
  jumpRankInfo = {
    label: '近5日',
    value: '5',
  };
  defaultValue = '最新';
  iframeHeight = '0';
  isShowDehy = 0;
  dehyTabName = '';
  barHeight = 0;
  isShowReportBlock = false;
  // 上涨空间运营位
  upspaceBannerImg = '';
  // 设置壹号研报运营位
  yhybBannerImg = '';
  // 壹号研报地址
  yhybUrl = allLink.yihao;
  // 进入弹窗运营配置
  enterPopupConfig = {
    isShow: false,
  };
  // 顶部蓝条配置
  reportClassTipConfig = {
    isShow: false,
  };
  // 监听滚动
  @Watch('scrollTop')
  onScrollTopChanged(newValue: number, oldValue: number) {
    // 拦截掉IOS回弹
    if (newValue < 0) {
      return;
    }
    if (newValue === 0) {
      // 初始化
      this.initBar();
    }
    // 向上/向下滚动判断是否要展示 向下滑动
    const isShow = newValue < oldValue;
    // 正常滚动的位置是否已经出页面视窗
    this.getBarPosition(isShow, newValue);
  }
  handleSafeBar(e) {
    // 安全岛避免切换app导致swiper切换的问题
    e.preventDefault();
  }
  getBarPosition(isShow: boolean, newValue: number) {
    const height = this.barHeight;
    // 定位状态改变 定位top信息
    let { top, position } = this.barStyle;
    top = top.replace('px', '');
    if (isShow) {
      // 向下滑动处理
      const style = this.scrollDown(top, position, newValue, height);
      // 获取更新之后的状态
      top = style.top;
      position = style.position;
    } else {
      // 向下滑动处理
      const style = this.scrollUp(top, position, newValue, height);
      top = style.top;
      position = style.position;
    }
    // 根据导航栏位置设置swiper是否可以滑动
    if (top === '0') {
      // 可以切换
      this.mySwiper && this.mySwiper.enable();
    } else {
      // 不可以切换
      this.mySwiper && this.mySwiper.disable();
    }
    // 设置位置信息
    this.barStyle = {
      top: `${top}px`,
      position,
    };
  }
  scrollUp(barTop, barPosition, scrollNewValue, height) {
    let position = barPosition;
    let top = barTop;
    const newValue = scrollNewValue;
    // 向上滑动
    if (position === 'fixed') {
      if (top === '0') {
        // 全部固定定位到顶部状态 向上滚动设置为绝对定位 并滚动
        position = 'absolute';
        top = `${newValue}`;
      }
    } else {
      if (height + parseInt(top, 10) <= newValue) {
        // 头部模块已滚动隐藏 分模块部分需要吸顶
        position = 'fixed';
        top = `${-height}`;
      }
    }
    return {
      top,
      position,
    };
  }
  scrollDown(barTop, barPosition, scrollNewValue, height) {
    // 向下滚动
    let position = barPosition;
    let top = barTop;
    const newValue = scrollNewValue;
    if (position === 'absolute') {
      if (top >= `${newValue}`) {
        // 向下绝对定位 头部已经要离开页面顶部 固定定位吸顶
        top = '0';
        position = 'fixed';
      }
    } else {
      if (top < '0') {
        // 头部公共部分还在隐藏 设置固定定位可以滚动
        position = 'absolute';
        top = `${newValue - height}`;
      } else {
        // 头部已经要离开页面顶部 固定定位吸顶
        position = 'fixed';
        top = '0';
      }
    }
    return {
      top,
      position,
    };
  }
  hidescreen() {
    const ref = this.$refs.allscreen as any;
    ref.closeMask();
  }
  updateAllSelectInfo(queryInfo) {
    this.allReportSelecter.queryInfo = queryInfo;
  }
  changeAllSelectInfo(info: dropMenuProject) {
    // 处理选中的时间
    this.allReportSelecter.period = info.value;
  }
  //screenShow为0状态下改变下拉框的值时一起改变1，2状态下的下拉框值
  changeSelect(label: any) {
    this.defaultValue = label;
  }
  selected(item: any) {
    const child = this.$refs.child as any;
    child.selected(item);
  }
  setRankDate(info) {
    this.jumpRankInfo = info;
  }
  toSearch() {
    // 直接跳转去搜索 搜索页需要自动focus
    window.hxmPageStat(`${STAT.homeRecommend}.sousuo`, URLVER);
    pushBy2804('/search', null);
  }
  handleMainTabClick(index: number) {
    // 将swiper状态设置为可以切换
    this.mySwiper && this.mySwiper.enable();
    // 处理数据 这里可以优化一下组件
    this.tabList = this.handleTabClick(index, this.tabList);
    // 激活对应的swiper
    this.mySwiper?.slideTo(index);
    // 将页面滚动到顶部
    window.scrollTo(0, 0);
  }
  handleTabClick(index: number, arr: tabProject[]): tabProject[] {
    this.activeTabIndex = index;
    // 切换slide将当前slide高度置为auto，其他置为0，为的是防止slide高度互相影响
    const swiper = document.getElementsByClassName('swiper-wrapper')[0].children;
    for (let i: number = 0; i < swiper.length; i++) {
      const slide = swiper[i] as HTMLElement;
      if (this.isShowDehy === 1 && index === 0) {
        slide.style.height = this.iframeHeight;
      } else if (i === index) {
        slide.style.height = 'auto';
      } else {
        slide.style.height = '0';
      }
    }
    return arr.map((item: tabProject, inn: number) => {
      item.isActive = false;
      if (inn === index) {
        item.isActive = true;
      }
      return item;
    });
  }
  initSwiper() {
    const that = this;
    // eslint-disable-next-line no-unused-vars
    this.mySwiper = new Swiper('#home-main-swiper', {
      initialSlide: that.activeTabIndex,
      autoplay: false,
      on: {
        slideChangeTransitionEnd() {
          // 初始化bar位置
          window.scrollTo(0, 0);
        },
        slideChangeTransitionStart(swiper) {
          that.tabList = that.handleTabClick(swiper.realIndex, that.tabList);
        },
      },
    });
  }
  initBar() {
    // 搜索和主tab定位默认
    this.barStyle = {
      top: '0px',
      position: 'absolute',
    };
    // swiper内部元素定位
    this.selectPosition = {
      top: '1.8rem',
      position: 'absolute',
    };
  }
  radioChartChange() {
    this.chart = !this.chart;
  }
  radioDeepChange() {
    this.deep = !this.deep;
    window.scrollTo(0, 0);
  }
  getScrollTop() {
    this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
  }
  handleScroll() {
    window.addEventListener('scroll', this.getScrollTop);
  }
  toRank() {
    // 跳转排行榜查看更多
    pushBy2804('/rank', {
      // 用来跳转rank激活指定的swiper和tab
      tab: '1',
      industrydate: this.jumpRankInfo.label,
      industryselect: this.jumpRankInfo.value,
    });
  }
  initBarHeight() {
    const bar = this.$refs.homebar as HTMLElement;
    this.barHeight = bar.clientHeight;
  }
  onShowHandler() {
    // 监听onshow协议触发更新关注状态
    registerWebListener('onShow', () => {
      this.$syncFollow();
    });
  }
  getTabIndex(tab: string): number {
    // 获取tab类型在tab列表中的索引
    if (tab) {
      const index = this.tabList.findIndex(item => item?.tab === tab);
      return index >= 0 ? index : this.isShowDehy;
    } else {
      return this.isShowDehy;
    }
  }
  initSlide() {
    // 处理tab信息
    const id = window.getParam('industryId');
    const jumpTab = window.getParam('jumpTab');
    let index = this.getTabIndex(jumpTab);
    if (id || jumpTab === 'all') {
      index = this.getTabIndex('all');
      if (id) {
        // 从个股/分时过来
        this.allReportSelecter.queryInfo = {
          industry_id: id,
        };
      } else {
        // 从手炒首页热门研报过来 选择器变更
        this.allDefault = '近24h最热';
        this.allReportSelecter.period = '1d';
      }
    }
    if (index > this.isShowDehy) {
      // 如果大于默认的推荐tab 需要切换tab
      this.activeTabIndex = index;
      this.tabList = this.handleTabClick(index, this.tabList);
    }
    this.initSwiper();
  }
  initPage() {
    // 初始化swiper，需要判断链接中是否有行业id信息
    this.initSlide();
    // 滚动监听
    this.handleScroll();
    // 监听onshow更新关注信息
    this.onShowHandler();
  }
  initTab() {
    this.$pageStatus.loading();
    getOperateConfig({ key: 'yyggpz' })
      .then(res => {
        if (res.statusCode === 0 && res.data.yyggpz?.length) {
          const yyggpz = res.data.yyggpz[0];
          // 运营位处理
          this.initYunYing(yyggpz);
        }
        this.initBusinessConfig();
        this.$nextTick(() => this.initPage());
      })
      .catch(() => {
        this.initPage();
      })
      .finally(() => {
        this.$pageStatus.close();
        this.isShowReportBlock = true;
      });
  }
  initYunYing(yyggpz: any) {
    // 设置精选tab 备用域名情况下精选tab下的iframe无法获取客户端协议可能存在问题 做一下隐藏兜底
    if (yyggpz.ybtab && location.host.includes('10jqka.com.cn')) {
      // iframe嵌入并通信 跨域问题处理
      this.activeTabIndex = 1;
      this.isShowDehy = 1;
      this.iframeHeight = `${getClientHeight() - this.barHeight}px`;
      const temp = [
        {
          name: yyggpz.ybtab,
          isActive: false,
          stat: `${STAT.homeRecommend}.yhyanbao`,
          tab: 'yhyb',
        },
      ];
      this.tabList = temp.concat(homeTabList);
      // 域名切换动态主域名
      document.domain = location.hostname.slice(location.hostname.indexOf('.') + 1);
      this.iframeTouch();
    }
    // 设置壹号研报
    if (yyggpz.ybnrtab) {
      this.dehyTabName = yyggpz.ybnrtab;
    }
    // 设置上涨潜力运营位
    if (yyggpz.szql === 'sz') {
      this.upspaceBannerImg = yyggpz.ssqlsz.qlsz.url;
    }
    if (yyggpz.szql === '0') {
      this.upspaceBannerImg = 'none';
    }
    // 设置壹号研报运营位
    if (yyggpz.yhybyyw === 'yhybsz') {
      this.yhybBannerImg = yyggpz.yhybrq.yhybtpsz.url;
    }
    if (yyggpz.yhybyyw === '0') {
      this.yhybBannerImg = 'none';
    }
  }
  // ZENGZHANG-1841 研报宫格运营位迭代
  initBusinessConfig() {
    getOperateConfig({ key: 'ybggyyw' })
      .then(data => {
        if (data.statusCode === SUCCESS_CODE) {
          const {
            data: {
              ybggyyw: [config],
            },
          } = data;
          if (!Object.keys(config).length) {
            return;
          }
          // 校验跳转参数
          const checkActionType = val =>
            [BUSINESS_CONFIG.ACTION_TYPE.SLIDE, BUSINESS_CONFIG.ACTION_TYPE.JUMP_URL].includes(Number(val));
          const isShowPopup = val =>
            [BUSINESS_CONFIG.SHOW_TYPE.IS_POPUP, BUSINESS_CONFIG.SHOW_TYPE.IS_FLOAT].includes(Number(val));
          // 进入弹窗或悬浮弹窗配置
          const enterPopupConfig = {
            isShow: isShowPopup(config.ybtc) && checkActionType(config.tcdw) && config.sctp?.url,
            isPopup: Number(config.ybtc) === BUSINESS_CONFIG.SHOW_TYPE.IS_POPUP,
            bg: config.sctp?.url,
            actionType:
              Number(config.tcdw) === BUSINESS_CONFIG.ACTION_TYPE.SLIDE
                ? BUSINESS_CONFIG.ACTION_LABEL.SLIDE
                : BUSINESS_CONFIG.ACTION_LABEL.JUMP_URL,
            jumpUrl: config.rongqi2?.tclink?.url,
          };
          this.enterPopupConfig = enterPopupConfig;
          const reportClassTipConfig = {
            isShow: checkActionType(config.dwdt),
            text: config?.dblt,
            actionType:
              Number(config.dwdt) === BUSINESS_CONFIG.ACTION_TYPE.SLIDE
                ? BUSINESS_CONFIG.ACTION_LABEL.SLIDE
                : BUSINESS_CONFIG.ACTION_LABEL.JUMP_URL,
            jumpUrl: config.rongqi1?.ltink?.url,
          };
          this.reportClassTipConfig = reportClassTipConfig;
          // 进入页面的默认 tab
          if (Number(config?.mrtab) === BUSINESS_CONFIG.DEFAULT_ACTION.SHOW_DEHY_REPORT && this.isShowDehy) {
            this.handleMainTabClick(SWIPER_FIRST_INDEX);
          }
        }
      })
      .catch(() => {
        // 接口失败不进行配置
      });
  }
  handleOperateAction(actionConfig) {
    if (actionConfig.actionType === BUSINESS_CONFIG.ACTION_LABEL.JUMP_URL) {
      actionConfig.jumpUrl && jumpBy2804(actionConfig.jumpUrl);
    } else {
      if (this.isShowDehy) {
        this.handleMainTabClick(SWIPER_FIRST_INDEX);
      }
    }
  }
  iframeTouch() {
    const that = this;
    const originHost = `https://${
      location.hostname.includes('testm') ? 'testm' : 'vaserviece'
    }.10jqka.com.cn`;
    const pay = new Pay(that);
    window.addEventListener('message', function (e) {
      if (e.origin === that.yhybUrl.slice(0, that.yhybUrl.indexOf('/dehydrationReport/'))) {
        const { data } = e;
        switch (data.type) {
          case 'changeswiper':
            //处理touch事件
            that.mySwiper.slideTo(1);
            break;
          case 'clickstat':
            // 处理iframe捕获不到埋点问题
            window.hxmClickStat(data.stat, data.ver);
            break;
          case 'jump':
            jumpBy2804(data.url);
            break;
          case 'stock':
            // 跳转分时
            jumpTimeShare({ stockCode: data.stockCode });
            break;
          case 'login':
            const reload = () => window.location.reload();
            // 登录之后刷新一下页面
            appLogin(reload, reload);
            break;
          case 'setStorage':
            // ZENGZHANG-1303 处理iframe壹号研报中localStorage丢失问题
            // 设置研报页面的localStorage
            localStorage.setItem(data.key, data.value);
            break;
          case 'getStorage':
            // 获取研报页面的localStorage，返回给子页面
            const value = localStorage.getItem(data.key);
            const iframe = document.getElementById('iframe-yhyb') as HTMLIFrameElement;
            iframe.contentWindow.postMessage(value, originHost);
            break;
          case 'pay':
            // THSCLASS-3998 研报内完成壹号研报的支付
            pay.toPay();
            break;
          default:
            break;
        }
      }
    });
  }
  async created() {
    // 壹号研报切换备用域名地址
    this.yhybUrl = await getUrlByPromise(allLink.yihao);
    // 初始化导航栏位置样式
    this.initBar();
    // 同步全局的关注
    this.$syncFollow();
    // 研报曝光埋点(weblog)
    statShow('ths_mob_yanbao');
    // 初始化回流
    initBackwash();
  }
  mounted() {
    window.hxmPageStat(STAT.homeRecommend, URLVER);
    // 获取导航栏的高度用于滚动监听
    this.initBarHeight();
    this.initTab();
  }
  beforeRouteLeave(to, from, next) {
    window.removeEventListener('scroll', this.getScrollTop);
    next();
  }
}
